module.exports = __webpack_public_path__ + "assets/system.cc447182.svg";